// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2mrku","errorLogs":"styles_errorLogs__37_0P"};